export default "__VITE_ASSET__DvUZkWdZ__"